import React, { FC } from 'react';

import styled from 'styled-components';

import { ISanityBlockContent } from '@rbi-ctg/menu';
import BlockRenderer from 'components/sanity-block-renderer';

interface SanityBlockContentProps {
  /**
   * Center the text
   *
   * @default false
   **/
  centered?: boolean;
  /**
   * The content as SanityBlockContent
   *
   * @default []
   **/
  content: ISanityBlockContent[];
  /**
   * Invert the text i.e. make it white
   *
   * @default false
   **/
  inverted?: boolean;
}

export interface TypographyContainerProps {
  centered: boolean;
  inverted: boolean;
}

export const TypographyContainer = styled(BlockRenderer)<TypographyContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: ${p => (p.centered ? 'center' : 'initial')};
  text-align: ${p => (p.centered ? 'center' : 'initial')};
  margin: 0;
  padding: 0;
  color: ${p => (p.inverted ? Styles.color.white : Styles.color.black)};
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.normal};

  strong {
    font-weight: ${Styles.fontWeight.black};
    letter-spacing: -1.82px;
  }
  em {
    font-family: ${Styles.fontFamily.brand};
    font-style: normal;
    font-weight: ${Styles.fontWeight.normal};
    color: ${p => (p.inverted ? Styles.color.white : Styles.color.primary)};
    letter-spacing: -0.5px;
  }
  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    padding: 0;
    line-height: 1;
    letter-spacing: -0.3px;
  }
  h1 {
    font-size: 4rem;
  }
  h2 {
    font-size: 3rem;
    font-weight: ${Styles.fontWeight.normal};
  }
  h3 {
    font-weight: ${Styles.fontWeight.normal};
  }
  h4 {
    font-weight: ${Styles.fontWeight.heavy};
  }
`;

export const SanityBlockContent: FC<SanityBlockContentProps> = ({
  centered = false,
  inverted = false,
  content = [],
  ...rest
}) => {
  return (
    <TypographyContainer centered={centered} content={content} inverted={inverted} {...rest} />
  );
};

export default SanityBlockContent;
